<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-body>
                        <h4 class="heading-1 mb-4">
                            <span>REQUISIÇÃO</span>
                        </h4>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                        <quadro-resumo-rateios
                            :requisicao="requisicao"
                        ></quadro-resumo-rateios>
                        <div class="d-flex">
                            <app-btn-voltar
                                :rota="rotaListagem"
                            ></app-btn-voltar>
                        </div>
                        <b-tabs class="mt-4">
                            <b-tab title="Dados Gerais" active>
                                <requisicao-detalhes
                                    :requisicao="requisicao"
                                ></requisicao-detalhes>
                            </b-tab>
                            <b-tab title="Itens da Requisição"
                                ><requisicao-itens
                                    v-if="requisicao"
                                    :requisicao="requisicao"
                                ></requisicao-itens
                            ></b-tab>
                            <b-tab title="Rateios"
                                ><requisicao-comprometimentos
                                    v-if="requisicao"
                                    :requisicao="requisicao"
                                    :dataServicos="dataServicos"
                                ></requisicao-comprometimentos
                            ></b-tab>
                            <b-tab
                                title="Envios"
                                v-if="requisicao && requisicao.emailsEnvios"
                            >
                                <requisicao-envios
                                    :requisicao="requisicao"
                                ></requisicao-envios>
                            </b-tab>
                        </b-tabs>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import RequisicaoItens from './RequisicaoItens'
import RequisicaoComprometimentos from './RequisicaoComprometimentos'
import QuadroResumoRateios from './QuadroResumoRateios'
import RequisicaoEnvios from './RequisicaoEnvios'
import RequisicaoDetalhes from './RequisicaoDetalhes'

export default {
    components: {
        QuadroResumoRateios,
        RequisicaoItens,
        RequisicaoComprometimentos,
        RequisicaoEnvios,
        RequisicaoDetalhes
    },

    props: {
        rotaListagem: {
            type: String
        },

        dataServicos: {
            type: Object
        }
    },

    data() {
        return {
            size1: '160',
            erros: [],
            requisicao: null
        }
    },

    methods: {
        obterRequisicao() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .obterPorId(this.$route.params.requisicaoId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.requisicao = response.data
                        } else {
                            this.erros = ['Erro ao obter requisição']
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {
        this.obterRequisicao()
    },

    watch: {}
}
</script>
